import React from 'react'
import { useTranslation } from 'react-i18next'
import './LanguageToggle.css'

const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation()
  const isEnglish = i18n.language === 'en'

  const toggleLanguage = () => {
    const newLang = isEnglish ? 'ar' : 'en'
    i18n.changeLanguage(newLang)
  }

  return (
    <div className={`language-switch ${className}`}>
      <input
        id="language-toggle"
        className="check-toggle check-toggle-round-flat"
        type="checkbox"
        checked={isEnglish}
        onChange={toggleLanguage}
      />
      <label htmlFor="language-toggle"></label>
      <span className="on">AR</span>
      <span className="off">EN</span>
    </div>
  )
}

export default LanguageToggle

